import CadastrosAdicionais from '@/enums/cadastros-adicionais';

export default [
  {
    key: CadastrosAdicionais.keys.ARMAZEM.key,
    description: CadastrosAdicionais.keys.ARMAZEM.description,
    type: CadastrosAdicionais.keys.ARMAZEM.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.NATUREZA.key,
    description: CadastrosAdicionais.keys.NATUREZA.description,
    type: CadastrosAdicionais.keys.NATUREZA.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
    description: CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.description,
    type: CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.TIPO_COBRANCA.key,
    description: CadastrosAdicionais.keys.TIPO_COBRANCA.description,
    type: CadastrosAdicionais.keys.TIPO_COBRANCA.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.OBSERVACAO_INTERNA.key,
    description: CadastrosAdicionais.keys.OBSERVACAO_INTERNA.description,
    type: CadastrosAdicionais.keys.OBSERVACAO_INTERNA.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    description: CadastrosAdicionais.keys.CONTA_CONTABIL.description,
    type: CadastrosAdicionais.keys.CONTA_CONTABIL.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    description: CadastrosAdicionais.keys.CONTA_FINANCEIRA.description,
    type: CadastrosAdicionais.keys.CONTA_FINANCEIRA.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.CONTA_DESPESA.key,
    description: CadastrosAdicionais.keys.CONTA_DESPESA.description,
    type: CadastrosAdicionais.keys.CONTA_DESPESA.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
  {
    key: CadastrosAdicionais.keys.OPERACAO.key,
    description: CadastrosAdicionais.keys.OPERACAO.description,
    type: CadastrosAdicionais.keys.OPERACAO.key,
    componentSuffix: 'cadastro-adicional',
    isCampoAdicional: true,
  },
];
